<div class="modal">
    <div class="back-btn" (click)="onCancelClick()"></div>
    <div class="modal-panel" *ngIf="data" [ngClass]="data.customClass ?? ''">
        <p>{{ data.message | translate }}</p>
        <div class="button-modal-container horizontal-focusable-container data-blocked"  data-blocked>
            <button  class="primary-button icon-button focusable-element" [attr.aria-label]=" data.buttonMessage | translate" tabindex="0" (click)="onActionProceed()">
                <app-icon *ngIf="data.buttonIcon" [name]="data.buttonIcon"></app-icon>
                {{ data.buttonMessage | translate }}</button>
        </div>
    </div>
</div>